/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'system';
const componentName = 'license-quota-config';
const prefix = `${moduleName}.${componentName}`;

export const licenseQuotaLabel = `${prefix}.licenseQuotaLabel`;
export const licenseReservationInputLabel = `${prefix}.licenseReservationInputLabel`;
export const licenseReservationInputPlaceholder = `${prefix}.licenseReservationInputPlaceholder`;
export const licenseLimitHelperText = `${prefix}.licenseLimitHelperText`;
export const licenseLimitInputLabel = `${prefix}.licenseLimitInputLabel`;
export const licenseLimitInputPlaceholder = `${prefix}.licenseLimitInputPlaceholder`;

export const ENGLISH = {
    [licenseQuotaLabel]: 'License Quota',
    [licenseReservationInputLabel]: 'License Reservation',
    [licenseReservationInputPlaceholder]: 'Enter License Reservation',
    [licenseLimitHelperText]: 'Special Value -1 for no limits',
    [licenseLimitInputLabel]: 'License Limit',
    [licenseLimitInputPlaceholder]: 'Enter License Limit',
};
